import { render, staticRenderFns } from "./assign-team-assets.vue?vue&type=template&id=0e0686c6&scoped=true"
import script from "./assign-team-assets.vue?vue&type=script&lang=js"
export * from "./assign-team-assets.vue?vue&type=script&lang=js"
import style0 from "./assign-team-assets.vue?vue&type=style&index=0&id=0e0686c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0686c6",
  null
  
)

export default component.exports